import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import HomePage from './pages/HomePage';
import PropertiesPage from './pages/PropertiesPage';
import PropertyDetailPage from './pages/PropertyDetailPage';
import EnquiryPage from './pages/EnquiryPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import AdminDashboard from './pages/admin/AdminDashboard';
import BidsAdminPage from './pages/BidsAdminPage';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/properties" element={<PropertiesPage />} />
          <Route path="/properties/:id" element={<PropertyDetailPage />} />
          <Route path="/enquiry" element={<EnquiryPage />} />
          
          {/* Client Auth Routes */}
          <Route path="/login" element={<LoginPage userType="client" />} />
          <Route path="/register" element={<RegisterPage userType="client" />} />
          
          {/* Landlord Auth Routes */}
          <Route path="/landlord/login" element={<LoginPage userType="landlord" />} />
          <Route path="/landlord/register" element={<RegisterPage userType="landlord" />} />
          
          {/* Admin Auth Routes */}
          <Route path="/admin/login" element={<LoginPage userType="admin" />} />
          <Route path="/admin/register" element={<RegisterPage userType="admin" />} />
          
          {/* Super Admin Routes */}
          <Route path="/super-admin" element={<AdminDashboard />} />
          <Route path="/super-admin/bids" element={<BidsAdminPage />} />
          
          {/* Landlord Routes */}
          <Route path="/landlord/dashboard" element={<AdminDashboard />} />
          <Route path="/landlord/bids" element={<BidsAdminPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;